module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+=''+
((__t=( multiline(t('community::contacts:empty')) ))==null?'':__t)+
'';
}
return __p;
};